export function calcPasswordStrength(password) {
  if (!password) return 0;
  let score = 0;
  if (password.length >= 6) score = 1;
  if (password.length >= 8) score = 2;
  if (password.length >= 8 && /[A-Z]/.test(password) && /[0-9]/.test(password)) score = 3;
  if (
    password.length >= 12 &&
    /[A-Z]/.test(password) &&
    /[0-9]/.test(password) &&
    /[^A-Za-z0-9]/.test(password)
  )
    score = 4;
  return score;
}

const LABELS = ["", "Weak", "Fair", "Good", "Strong"];
const COLORS = ["", "bg-pink", "bg-yellow", "bg-yellow", "bg-mint"];
const TEXT_COLORS = ["", "text-pink", "text-yellow", "text-yellow", "text-mint"];

export function PasswordStrength({ password }) {
  const score = calcPasswordStrength(password);
  if (!password) return null;
  return (
    <div className="mt-1.5 flex items-center gap-2">
      <div className="flex flex-1 gap-1">
        {[1, 2, 3, 4].map((seg) => (
          <div
            key={seg}
            className={`h-1 flex-1 rounded-full transition-all duration-300 ${seg <= score ? COLORS[score] : "bg-line"}`}
          />
        ))}
      </div>
      <span
        className={`shrink-0 font-mono text-2xs uppercase tracking-[0.22em] transition-colors duration-300 ${TEXT_COLORS[score]}`}
      >
        {LABELS[score]}
      </span>
    </div>
  );
}

export default PasswordStrength;
